require("./Bootstrap.js");
require("./Component");
require("./Filter");
import Vue from "vue";
import App from "./App";
import VueRouter from "vue-router";
import routes from "./routes.js";
import helper from "./plugins/helper";
import httpPlugin from "./plugins/http";
import storePlugin from "./plugins/store";
import ElementUI from "element-ui";
import common_toolbar from "./mixins/common_toolbar";

import "./app.scss";
import "./app.less";
// import 'babel-polyfill'

//代理商覆盖配置

Vue.config.productionTip = false;
// storePlugin.store.commit('changeAuth',{isLogin:true}) 加载用户信息

//参数设置
Vue.prototype.config = window.config;

/**
 * plugins
 */
Vue.use(VueRouter);
Vue.use(helper);
Vue.use(storePlugin);
Vue.use(ElementUI);

Vue.mixin(common_toolbar);

/**
 * Router
 */
const router = new VueRouter({
    mode: "history",
    linkActiveClass: "router-link-active",
    history: true,
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0,
            };
        }
    },
});

router.beforeEach((to, from, next) => {
    //路由发生变化修改页面titler
    if (to.meta.title) {
        document.title = to.meta.title + "-" + config.site_title;
    }

    storePlugin.store
        .dispatch("load_profile")
        .then((e) => {
            if (!to.meta.auth || e) {
                if (!to.meta.middleware) {
                    return next();
                } else {
                    const middleware = to.meta.middleware;
                    const store = storePlugin.store;

                     const context = {
                        to,
                        from,
                        next,
                        store,
                    };
                    return middleware({
                        ...context,
                    });
                }
            } else {
                next("/login");
            }
        })
        .catch((e) => {
            next();
        });
});

Vue.use(httpPlugin, router);

//事件总线
Vue.prototype.$event_bus = new Vue();

new Vue(
    Vue.util.extend(
        {
            router,
        },
        App
    )
).$mount("#app");
